import React, { useEffect } from "react";
import './ServiceImageAnimation.css';

const ServiceImageAnimation = () => {
  
    useEffect(() => {
      const featureItems = document.querySelectorAll('.feature-item');
  
      // Create an IntersectionObserver to detect scrolling up or down
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Add 'show' class when the element is in the viewport
            entry.target.classList.add('show');
          } else {
            // Remove 'show' class when the element is out of the viewport
            entry.target.classList.remove('show');
          }
        });
      }, {
        threshold: 0.5 // Trigger when 50% of the element is in the viewport
      });
  
      // Observe each feature item
      featureItems.forEach(item => observer.observe(item));
  
      // Cleanup the observer
      return () => {
        featureItems.forEach(item => observer.unobserve(item));
      };
    }, []);
    
    return (
        <div className="no-container-section">
          <div className="feature-item">
            <img src="/online-doctor-concept-illustration_114360-1783.jpg" alt="Virtual Health Consultations" />
            <div className="feature-text">
              <h3>Virtual Health Consultations</h3>
              <p>Connect with doctors online from anywhere.</p>
            </div>
          </div>

          <div className="feature-item">
            <img src="/online-medical-consultation-service-with-patient-female-doctor-computer-screen_7547-693.jpg" alt="Healthcare Coordination" />
            <div className="feature-text">
              <h3>Healthcare Coordination</h3>
              <p>Efficiently manage your healthcare needs with ease.</p>
            </div>
          </div>

          <div className="feature-item">
            <img src="/telemedicine-concept-illustration_114360-25800.jpg" alt="Virtual Healthcare Connections" />
            <div className="feature-text">
              <h3>Virtual Healthcare, Real Connections</h3>
              <p>Build meaningful connections with healthcare professionals.</p>
            </div>
          </div>
        </div>
    );
};

export default ServiceImageAnimation;